<template>
  <Modal v-model="collectionOfScrapFeesForLogisticsModal" :title="$t('key1000228')" width="700"
    :transfer="false" :mask-closable="false" @on-visible-change="collectionOfScrapFeesForLogisticsChange">
    <div class="mb20">
      <span>{{ $t('key1000230') }}</span>
      <span class="distributorThemeColor ml3 mr4">{{ timer }}</span>
      <span>{{ $t('key1000231') }}</span>
      <span class="distributorThemeColor">{{ $t('key1000229') + cancelPrice + ' ' + currencyState + '”。' }}</span>
      <span>{{ $t('key1000232') }}</span>
    </div>
    <div class="flex align-items-center mb15">
      <span class="distributorThemeColor">{{ $t('key1000233') }}</span>
      <span class="mr40">{{ formatCurrency(originalCost) + ' ' + currencyState + '；' }}</span>
      <span class="redColor">{{ $t('key1000234') }}</span>
      <span>{{ formatCurrency(refundAmount) + ' ' + currencyState }}</span>
    </div>
    <template #footer>
      <div style="text-align: right;">
        <Button @click="collectionOfScrapFeesForLogisticsModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="collectionOfScrapFeesForLogisticsBtn">{{ $t('key1000111') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {calculateDiffTime, getOrderLogisticsConsumption} from "@/utils/common";

export default {
  name: 'collectionOfScrapFeesForLogisticsModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      collectionOfScrapFeesForLogisticsModal: false,
      cancelPrice: 0,
      timer: null,
      originalCost: 0,
      refundAmount: 0,
    };
  },
  methods: {
    // 初始化数据
    initCollectionOfScrapFeesForLogisticsData(obj) {
      return new Promise((resolve, reject) => {
        this.originalCost = obj.totalPrice || 0;
        getOrderLogisticsConsumption(obj.ymsPackageId).then((data) => {
          if (data) {
            this.cancelPrice = data.cancelPrice || 0;
            this.refundAmount = obj.totalPrice - data.cancelPrice;
            let trackingNumberTime = obj.trackingNumberTime || '';
            if (trackingNumberTime) {
              trackingNumberTime = this.$uDate.dealTime(trackingNumberTime, 'fulltime');
              this.timer = calculateDiffTime(trackingNumberTime);
            }
            if (this.cancelPrice) {
              this.collectionOfScrapFeesForLogisticsModal = true;
            }
            resolve(this.cancelPrice);
          } else {
            reject();
          }
        });
      });
    },
    // 确定按钮
    collectionOfScrapFeesForLogisticsBtn() {
      this.$emit('updateSubmit', true);
      this.collectionOfScrapFeesForLogisticsModal = false;
    },
    // 监听弹窗
    collectionOfScrapFeesForLogisticsChange(value) {
      if (!value) {
        this.cancelPrice = 0;
        this.originalCost = 0;
        this.refundAmount = 0;
        this.timer = null;
      }
    }
  }
};
</script>

<style lang="less">

</style>
